import React from 'react'
import PropTypes from 'prop-types'
import styles from './styles.module.css'

function CarouselIndicators({ total, activeIndex, onClick }) {
  return (
    <div className={styles.wrapper}>
      {Array.from(Array(total)).map((currentIndicator, currentIndex) => {
        const active = currentIndex === activeIndex
        return <button onClick={() => onClick(currentIndex)} key={currentIndex} className={active ? `${styles.indicator} ${styles.indicatorActive}` : styles.indicator}></button>
      })}
    </div>
  )
}

CarouselIndicators.propTypes = {
  total: PropTypes.number,
  activeIndex: PropTypes.number
}
export default CarouselIndicators
